export default __webpack_public_path__ + "static/media/squareU.svg";